import { useEffect, useMemo, useState } from "react";
import { useIsMobile } from "@ac-expo/ui-components";
import FilterBarDesktop from "./FilterBarDesktop";
import FilterBarMobile from "./FilterBarMobile";
import filterStore from "@web-app/src/services/FilterStore";

export const MIN_FILTER_RESET_TRESHOLD = 2;

interface FilterBarProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export function FilterBar({ startDate, endDate }: FilterBarProps) {
  const isMobile = useIsMobile();

  const [radius, setRadius] = useState(filterStore.locationDistance);

  useEffect(() => {
    const timer = setTimeout(() => {
      filterStore.setLocationDistance(radius === 0 ? 1 : radius);
    }, 500);

    return () => clearTimeout(timer);
  }, [radius]);

  const onSetRadius = (radius: number) => {
    if (radius === 0) radius = 1;
    setRadius(radius);
  };

  const filterSelectedNumber = filterStore.filterSelectedNumber();

  const resetFilters = useMemo(() => {
    const canBeReset = filterSelectedNumber >= MIN_FILTER_RESET_TRESHOLD;
    const resetFn = () => {
      filterStore.resetStore();
      setRadius(20);
    };
    return canBeReset ? resetFn : undefined;
  }, [filterSelectedNumber]);

  return isMobile ? (
    <FilterBarMobile
      startDate={startDate}
      endDate={endDate}
      setRadius={onSetRadius}
      radius={radius}
      reset={resetFilters}
    />
  ) : (
    <FilterBarDesktop
      startDate={startDate}
      endDate={endDate}
      setRadius={onSetRadius}
      radius={radius}
      reset={resetFilters}
    />
  );
}

export default FilterBar;
